module.exports = __webpack_public_path__ + "static/media/hot52.50592565.png";